(function(){
function init(root){
if(!root||root.dataset.tkhReady)return;root.dataset.tkhReady='1';
var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function $(sel){return root.querySelector(sel)}
function $$(sel){return Array.prototype.slice.call(root.querySelectorAll(sel))}
function smooth(el){if(el)el.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'})}
/* --- Compteur de vols (estimation au rythme 2025 : 125 200 vols / an) --- */
var cEl=$('[data-tkh-count]'),bEl=$('[data-tkh-bar]');
if(cEl){
var RATE=125200/(365*24*3600);
var y0=new Date(new Date().getFullYear(),0,1).getTime();
var fmt=function(n){try{return n.toLocaleString('fr-FR')}catch(e){return String(n)}};
var tick=function(){var n=(Date.now()-y0)/1000*RATE;cEl.textContent=fmt(Math.floor(n));if(bEl)bEl.style.transform='scaleX('+(n%1).toFixed(4)+')'};
tick();setInterval(tick,1000);
}
/* --- Démo : véhicule sur la carte + coupure du moteur --- */
var app=$('[data-tkh-app]');
if(app){
var route=$('[data-tkh-route]'),car=$('[data-tkh-car]'),body=$('[data-tkh-carbody]'),spEl=$('[data-tkh-speed]'),enEl=$('[data-tkh-engine]');
var L=route.getTotalLength(),dist=L*0.15,v=1,state='moving',last=0,speedT=0,running=false,visible=true;
route.style.strokeDasharray=L+' '+L;
function place(){
var p=route.getPointAtLength(dist),a=route.getPointAtLength(Math.max(0,dist-2)),b=route.getPointAtLength(Math.min(L,dist+2));
car.setAttribute('transform','translate('+p.x.toFixed(1)+' '+p.y.toFixed(1)+')');
if(body&&(b.x!==a.x||b.y!==a.y))body.setAttribute('transform','rotate('+(Math.atan2(b.y-a.y,b.x-a.x)*180/Math.PI).toFixed(1)+') scale(1.25)');
route.style.strokeDashoffset=(L-dist).toFixed(1);
}
function setState(s){
state=s;app.setAttribute('data-state',s);
if(s==='moving'){enEl.textContent='Démarré'}
if(s==='braking'){enEl.textContent='Coupure…'}
if(s==='blocked'){enEl.textContent='Coupé';spEl.textContent='0'}
}
function frame(t){
if(!visible){running=false;last=0;return}
var dt=last?Math.min((t-last)/1000,.05):0;last=t;
if(state==='moving'){v=Math.min(1,v+dt*.8)}
else if(state==='braking'){v=Math.max(0,v-dt*.75);if(v===0)setState('blocked')}
if(v>0){dist+=v*34*dt;if(dist>=L){dist=0}}
place();
speedT+=dt;
if(speedT>.6&&state!=='blocked'){speedT=0;spEl.textContent=state==='braking'?Math.round(42*v):Math.round(36+Math.random()*14)}
requestAnimationFrame(frame);
}
function start(){if(!running&&!reduce){running=true;requestAnimationFrame(frame)}}
if(reduce){dist=L*.55;place()}else{start()}
if('IntersectionObserver' in window){new IntersectionObserver(function(es){visible=es[0].isIntersecting;if(visible)start()}).observe(app)}
var slide=$('[data-tkh-slide]'),knob=$('[data-tkh-knob]'),fill=$('[data-tkh-fill]'),lab=$('[data-tkh-label]'),reset=$('[data-tkh-reset]');
var dragging=false,sx=0,x=0;
function maxX(){return slide.clientWidth-knob.offsetWidth-8}
function setX(nx,anim){x=Math.max(0,Math.min(maxX(),nx));knob.style.transition=anim?'transform .3s ease':'none';fill.style.transition=anim?'width .3s ease':'none';knob.style.transform='translateX('+x+'px)';fill.style.width=(x+60)+'px'}
function block(){
setX(maxX(),true);slide.classList.add('is-done');lab.textContent='Moteur coupé';
knob.setAttribute('aria-label','Moteur coupé (démonstration)');knob.disabled=true;
setState(reduce?'blocked':'braking');reset.hidden=false;
}
function unblock(){
setX(0,true);slide.classList.remove('is-done');lab.textContent='Glissez pour couper le moteur';
knob.setAttribute('aria-label','Couper le moteur (démonstration)');knob.disabled=false;reset.hidden=true;v=0;setState('moving');
}
knob.addEventListener('pointerdown',function(e){if(knob.disabled)return;dragging=true;sx=e.clientX-x;knob.setPointerCapture(e.pointerId)});
knob.addEventListener('pointermove',function(e){if(dragging)setX(e.clientX-sx,false)});
function nudge(){setX(46,true);setTimeout(function(){setX(0,true)},320)}
function end(){if(!dragging)return;dragging=false;if(x>maxX()*.82){block()}else if(x<6){nudge()}else{setX(0,true)}}
knob.addEventListener('pointerup',end);knob.addEventListener('pointercancel',end);
knob.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '||e.key==='ArrowRight'){e.preventDefault();block()}});
knob.addEventListener('click',function(e){if(e.detail===0)block()});
reset.addEventListener('click',unblock);
window.addEventListener('resize',function(){setX(state==='moving'?0:maxX(),false)});
}
/* --- Option anti-brouillage : prix mis à jour --- */
$$('[data-tkh-pack]').forEach(function(pack){
var cb=pack.querySelector('[data-tkh-optin]'),tot=pack.querySelector('[data-tkh-total]'),cta=pack.querySelector('[data-tkh-packcta]');
if(!cb||!tot)return;
var base=parseInt(pack.getAttribute('data-base'),10),opt=parseInt(pack.getAttribute('data-opt'),10),orig=tot.textContent;
cb.addEventListener('change',function(){
if(cb.checked&&base&&opt){tot.textContent=(base+opt)+' €'}else{tot.textContent=orig}
if(cta)cta.setAttribute('data-tkh-goto',cb.checked?'Traceur + coupe-moteur + option anti-brouillage':'Traceur + coupe-moteur');
});
});
/* --- Boutons : aller au formulaire avec la bonne prestation --- */
var presta=$('[data-tkh-presta]'),quote=$('#tkh-devis');
function goto(val){
if(presta&&val){for(var i=0;i<presta.options.length;i++){if(presta.options[i].text===val){presta.selectedIndex=i}}}
smooth(quote);
setTimeout(function(){var f=$('#tkh-f-name');if(f){try{f.focus({preventScroll:true})}catch(e){f.focus()}}},reduce?0:600);
}
root.addEventListener('click',function(e){
var a=e.target.closest('[data-tkh-goto]');
if(a){e.preventDefault();goto(a.getAttribute('data-tkh-goto'));return}
var sc=e.target.closest('[data-tkh-scroll]');
if(sc){var t=root.querySelector(sc.getAttribute('href'));if(t){e.preventDefault();smooth(t)}}
});
/* --- Guide de choix --- */
var guide=$('[data-tkh-guide]');
if(guide){
var res=$('[data-tkh-res]'),rt=$('[data-tkh-res-t]'),rd=$('[data-tkh-res-d]'),rc=$('[data-tkh-res-cta]');
var obd='/products/tracker-obd-batterie-illimite-sans-fil-traceur-gps-obd-4g-sans-abonnement';
guide.addEventListener('change',function(){
var veh=(guide.querySelector('input[name^="tkh-veh"]:checked')||{}).value;
var want=(guide.querySelector('input[name^="tkh-want"]:checked')||{}).value;
if(!want){return}
var t,d,c,href='#tkh-devis',go=null;
if(veh==='moto'&&want!=='seul'){t='Traceur aimanté';d='Nous n’installons pas de traceur sur les motos et scooters. La bonne solution : un traceur aimanté sans fil, que vous cachez vous-même. Sans abonnement.';c='Voir les traceurs aimantés';href='#tkh-shop-t'}
else if(want==='bloquer'){t='Traceur + coupe-moteur';d='La protection la plus complète : vous suivez votre véhicule et coupez son moteur à distance. Pose à domicile, déplacement offert en Île-de-France.';c='Réserver cette installation';go='Traceur + coupe-moteur'}
else if(want==='pose'){t='Traceur suivi seul';d='Localisation à distance, boîtier caché et alimenté par le véhicule : rien à recharger. Pose à domicile, déplacement offert en Île-de-France.';c='Réserver cette installation';go='Traceur suivi seul'}
else if(veh==='moto'||veh==='autre'){t='Traceur aimanté';d='Il fonctionne sur batterie et se cache n’importe où, même sans prise diagnostic. Sans abonnement.';c='Voir les traceurs aimantés';href='#tkh-shop-t'}
else{t='Traceur OBD';d='Il se branche en quelques secondes sur la prise diagnostic et reste alimenté par le véhicule. Sans abonnement.';c='Voir le traceur OBD';href=obd}
rt.textContent=t;rd.textContent=d;rc.textContent=c;rc.setAttribute('href',href);
if(go){rc.setAttribute('data-tkh-goto',go)}else{rc.removeAttribute('data-tkh-goto')}
if(href.charAt(0)==='#'&&!go){rc.setAttribute('data-tkh-scroll','')}else{rc.removeAttribute('data-tkh-scroll')}
res.hidden=false;
});
}
/* --- Barre d'action mobile --- */
var bar=$('[data-tkh-dock]'),hero=$('[data-tkh-herocta]');
if(bar&&hero&&'IntersectionObserver' in window){
var heroVis=true,quoteVis=false;
function upd(){var on=!heroVis&&!quoteVis;bar.classList.toggle('is-on',on);document.body.classList.toggle('tkh-bar-pad',on)}
new IntersectionObserver(function(es){heroVis=es[0].isIntersecting;upd()}).observe(hero);
if(quote)new IntersectionObserver(function(es){quoteVis=es[0].isIntersecting;upd()},{rootMargin:'0px 0px -40% 0px'}).observe(quote);
}
/* --- Après envoi du formulaire --- */
if(location.search.indexOf('contact_posted=true')>-1&&quote){setTimeout(function(){quote.scrollIntoView()},50)}
}
function all(){var r=document.querySelectorAll('[data-tkh-root]');for(var i=0;i<r.length;i++)init(r[i])}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',all)}else{all()}
document.addEventListener('shopify:section:load',all);
})();